import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";
import { jwtDecode } from "jwt-decode";
import type { AccessTokenClaims, RefreshTokenClaims } from "./auth-schema";

const makeTokenAtom = (key: string) =>
  atomWithStorage<string | null>(
    key,
    null,
    createJSONStorage(() => window.localStorage),
    {
      getOnInit: true,
    }
  );

export const refreshTokenAtom = makeTokenAtom("refresh_token");
export const accessTokenAtom = makeTokenAtom("access_token");

export const tokenAtom = atom((get) => {
  const token = get(accessTokenAtom);
  if (!token) {
    return null;
  }
  return jwtDecode<AccessTokenClaims>(token);
});

export const refreshTokenClaimsAtom = atom((get) => {
  const token = get(refreshTokenAtom);
  if (!token) {
    return null;
  }
  return jwtDecode<RefreshTokenClaims>(token);
});
